<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle />
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{$t('informedConsent.consentModelCode')}}</dt>
              <dd class="col-sm-9">{{ informationConsent.consentModelCode }}</dd>
              <dt class="col-sm-3">{{$t('informedConsent.consentModelDescription')}}</dt>
              <dd class="col-sm-9">{{ informationConsent.consentModelDescription }}</dd>
              <dt class="col-sm-3">{{$t('informedConsent.informationModelCode')}}</dt>
              <dd class="col-sm-9">{{ informationConsent.informationModelCode }}</dd>
              <dt class="col-sm-3">{{$t('informedConsent.informationModelDescription')}}</dt>
              <dd class="col-sm-9">{{ informationConsent.informationModelDescription }}</dd>
              <dt class="col-sm-3">{{$t('informedConsent.regionLabel')}}</dt>
              <dd class="col-sm-9">{{ informationConsent.regionLabel }}</dd>
              <dt class="col-sm-3">{{$t('informedConsent.validityFromDate')}}</dt>
              <dd class="col-sm-9">{{ formatDate(informationConsent.validityStartDate) }}</dd>
              <dt class="col-sm-3" v-if="informationConsent.validityEndDate">{{$t('informedConsent.validityEndDate')}}</dt>
              <dd class="col-sm-9" v-if="informationConsent.validityEndDate">{{ formatDate(informationConsent.validityEndDate) }}</dd>
            </dl>
          </div>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <router-link
                  tag="button"
                  class="btn btn-block btn-primary float-right col-2"
                  role="button"
                  :to="`/informationConsents/edit/${informationConsent.id}`"
                >
                  {{ $t('actions.edit') }}
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import PageTitle from "../../components/PageTitle";
import moment from "moment";
import InformationConsentService from "../../services/InformationConsentService";
const informationConsentService = InformationConsentService.build();

export default {
  name: "InformationConsentShow",
  components: {
    PageTitle
  },
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      informationConsent: {}
    }
  },
  created() {
    miniToastr.init();
    miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
    this.fetchData()
  },
  methods: {
    formatDate (date) {
      if (!date)
        return null

      return moment(date).format('DD/MM/YYYY');
    },
    async fetchData() {
      this.informationConsent = await informationConsentService.read(this.id)
    }
  }
}
</script>
